<template>
  <div class="row">
    <div class="col-12 col-md-2">
      <anosafra-multiselect
        v-model="filters.anosafra"
        label="Ano Safra"
      />
    </div>
    <div class="col-12 col-md-2">
      <label class="form-control-label">Filial</label>
      <multiselect 
        v-model="filters.branch" 
        :options="branches" 
        placeholder="Selecionar Filial" 
        label="name" 
        v-loading="isLoadingBranches"
        :selected-label="'Selecionado'" 
        track-by="id" 
      />
    </div>
    <div class="col-12 col-md-2">
      <label class="form-control-label">Status</label>
      <multiselect 
        v-model="filters.status" 
        :options="statuses" :select-label="''"
        placeholder="Escolha um Status" 
        :deselect-label="''" 
        :selected-label="'Selecionado'" 
        label="name" 
        track-by="value" 
      />
    </div>
    <div class="col-12 col-md-3">
      <label class="form-control-label">Vendedor</label>
      <multiselect 
        v-model="filters.salesman" 
        :options="salesmans" 
        :loading="isLoadingSalesman" 
        v-loading="isLoadingSalesman"
        :select-label="''" 
        :deselect-label="''" 
        :selected-label="'Selecionado'" 
        :disabled="!(
            currentUser.is_admin ||
            currentUser.is_manager ||
            currentUser.has_coordinateds
          ) " 
        @search-change="getSalesmans" 
        placeholder="Escolha um vendedor" 
        label="name" 
        track-by="id">
      </multiselect>
    </div>
    <div class="col-12 col-md-3">
      <base-input v-model="filters.name" label="Nome" placeholder="Nome da Região" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance, defineProps, defineEmits, watch } from 'vue';
import store from '@/store/index.js';
import axios from "@/backend/axios/index.js";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";

const emit = defineEmits(['update:filters']);

const props = defineProps({
  filters: Object,
});

const filters = computed({
  get: () => props.filters,
  set: (value) => emit('update:filters', value),
});

const branches  = ref([]);
const anosafras = ref([]);
const salesmans = ref([]);
const statuses  = ref([{ name: "ativo", value: 'true' }, { name: "inativo", value: 'false' }]);

const isLoadingBranches  = ref(false);
const isLoadingAnosafras = ref(false);
const isLoadingSalesman  = ref(false);

const currentUser = computed(() => getCurrentInstance().proxy.$currentUser());

const getBranches = async () => {
  isLoadingBranches.value = true;
  try {
    const response = await axios.get('/api/v1/branches');
    branches.value = response.data;
  } catch (error) {
    console.error('[RegionFilterForm.vue] getBranches', error);
  }
  isLoadingBranches.value = false;
};
const getSalesmans = async (query = '') => {
  isLoadingSalesman.value = true;

  var data = {
    per_page: 10,
    q: { name: query, is_salesman: true, anosafra_id: filters.value.anosafra.id },
  };

  try {
    const response = await axios.get("/api/v1/users", { params: data })
    
    salesmans.value = response.data.users || [];
  } catch (error) {
    console.error('[RegionFilterForm.vue] getSalesmans', error);
  }

  isLoadingSalesman.value = false;
}

const setCurrentAnosafra = () => {
  filters.value = {
    ...filters.value,
    anosafra: store.state.currentAnosafra,
  }
};

const reset = () => {
  console.log("[RegionFilterForm.vue] resetting filters");

  filters.value = {
    name: '',
    branch: null,
    status: statuses.value[0],
    salesman: null,
  };

  setCurrentAnosafra();
}

watch(() => filters.value.anosafra, () => {
  filters.value.salesman = null;

  getSalesmans();
});

watch(() => filters.value.manager, () => {
  filters.value.salesman = null;

  getSalesmans();
});

onMounted(() => {
  reset();
  getBranches();
  getSalesmans();
});
</script>
